import { render, staticRenderFns } from "./TagCustomV2.vue?vue&type=template&id=46e95936&scoped=true"
import script from "./TagCustomV2.vue?vue&type=script&lang=js"
export * from "./TagCustomV2.vue?vue&type=script&lang=js"
import style0 from "./TagCustomV2.vue?vue&type=style&index=0&id=46e95936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e95936",
  null
  
)

export default component.exports